/* eslint-disable no-underscore-dangle */
import { RequestError, RequestOptions, RequestPromise, RequestResponse } from './types';

export function isStream(stream) {
  return stream !== null && typeof stream === 'object' && typeof stream.pipe === 'function';
}

export function isReadableStream(stream) {
  return (
    isStream(stream) &&
    stream.readable !== false &&
    typeof stream._read === 'function' &&
    typeof stream._readableState === 'object'
  );
}

export function hasBuffer() {
  return typeof Buffer !== 'undefined';
}

export function timeout<T>(
  request: () => RequestPromise,
  abortController: AbortController | undefined,
  options: RequestOptions
): Promise<RequestResponse<T>> {
  return new Promise((resolve, reject) => {
    const timeoutId = setTimeout(() => {
      if (abortController) {
        abortController.abort();
      }
      reject(new RequestError(options.timeoutMessage || `timeout of ${options.timeout}ms exceeded`, options));
    }, options.timeout);
    request()
      .then(resolve)
      .catch(reject)
      .then(() => clearTimeout(timeoutId));
  });
}

export function uriParse(uri: string) {
  const fullReg = /^(https?:)\/\/(([^:/?#]*)(?::([0-9]+))?)([/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/;
  const pathReg = /^(([^:/?#]*)(?::([0-9]+))?)([/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/;
  const matchFull = uri.match(fullReg);
  const matchPath = uri.match(pathReg);
  return matchFull
    ? {
        uri,
        protocol: matchFull[1],
        host: matchFull[2],
        hostname: matchFull[3],
        port: matchFull[4],
        pathname: matchFull[5],
        search: matchFull[6],
        hash: matchFull[7],
      }
    : {
        uri,
        host: matchPath[1],
        hostname: matchPath[2],
        port: matchPath[3],
        pathname: matchPath[4],
        search: matchPath[5],
        hash: matchPath[6],
      };
}

/**
 * 拼出验证码跳转链接（TypeScript 版）
 * @param captchaRes  后端或前端返回的 block_info（字段可能缺失）
 * @param maimaiHost  可选，默认 https://maimai.cn
 */
export function getCaptchaUrl(captchaRes: Record<string, any>, maimaiHost = 'https://maimai.cn'): string {
  // 当前页完整地址
  const currentTarget: string =
    window.location.protocol + '//' + window.location.host + window.location.pathname + window.location.search;

  // 手工 stringify，无三方库
  const stringify = (obj: Record<string, any>): string =>
    Object.keys(obj)
      .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(String(obj[key]))}`)
      .join('&');

  const query = stringify({
    to: currentTarget,
    session_id: captchaRes.session_id || '',
    captcha_id: captchaRes.captcha_id || '',
    captcha_type: captchaRes.captcha_type || '',
    countdown: captchaRes.countdown || 0,
  });

  return `${maimaiHost.replace(/\/$/, '')}/n/platform/ban/captcha?${query}`;
}
